import { render, staticRenderFns } from "./PencilIcon.vue?vue&type=template&id=02e4bc82&"
import script from "./PencilIcon.vue?vue&type=script&lang=js&"
export * from "./PencilIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports